import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_PREFERREDACCOUNT: MijnRoute = {
    path: 'voorkeursrekening-beheren',
    navigationEvent: 'toVoorkeursrekeningBeheren',
    regex: /^\/zelf-regelen\/voorkeursrekening-beheren$/,
    webcomponent: 'mijn-klant-voorkeursrekening-webcomponent'
};
